
import { withAuthRetry } from '../utils/authRetry';
import { ModifySectionRequest, ModifySectionResponse } from '../modifysection';
import { getServiceUrl } from '../utils/api';

export async function modifySection(
    request: ModifySectionRequest,
    accessToken: string,
    setAccessToken: (token: string | null) => void,
    logout: () => void
): Promise<ModifySectionResponse> {
    const originalApiCall = async (token: string): Promise<Response> => {
        const headers = {
            'Content-Type': 'application/protobuf',
            'Authorization': 'Bearer ' + token
        };

        const url = getServiceUrl('reviewservice', 'modifysection');

        const bodyBytes = ModifySectionRequest.encode(request).finish();

        const response = await fetch(url, {
            method: 'POST',
            headers,
            body: bodyBytes
        });
        return response;
    };

    const decodeResponse = (bytes: Uint8Array): ModifySectionResponse => {
        return ModifySectionResponse.decode(bytes);
    };

    return withAuthRetry(originalApiCall, accessToken, decodeResponse, setAccessToken, logout);
}
